import React from "react";
import styled from "styled-components";

const FooterContainer = styled.footer`
  background: #f8f9fa;
  border-top: 3px solid #b28767;
  padding: 32px 0 16px 0;
  text-align: center;
  @media (max-width: 600px) {
    padding: 18px 0 8px 0;
  }
`;

const FooterText = styled.p`
  color: #444;
  font-size: 1rem;
  margin: 0;
  @media (max-width: 600px) {
    font-size: 0.95rem;
  }
`;

const Footer = () => (
  <FooterContainer>
    <FooterText>
      © {new Date().getFullYear()} Prisma Organizacional. Todos os direitos
      reservados.
    </FooterText>
  </FooterContainer>
);

export default Footer;
